import { render, staticRenderFns } from "./productManage.vue?vue&type=template&id=08e2542e&scoped=true"
import script from "./productManage.vue?vue&type=script&lang=js"
export * from "./productManage.vue?vue&type=script&lang=js"
import style0 from "./productManage.vue?vue&type=style&index=0&id=08e2542e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e2542e",
  null
  
)

export default component.exports